<template>
  <!-- 菜单权限管理 -->
  <div class="paddbox autobox">
    <div>
      <el-card>
        <div class="btn-toolbar">
          <el-button type="primary" size="mini" icon="el-icon-folder-opened" @click="openGlobalTemplatePage">
            模板管理
          </el-button>
        </div>
        <el-divider></el-divider>
        <!-- table部分 -->
        <div></div>
        <!-- 分页 -->
        <div class="pagination">
          <paginationMax100 @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"
            :total="total" :pagesize="pagesize" :currentPage="currentPage"></paginationMax100>
        </div>
      </el-card>
    </div>

    <div>
    </div>
  </div>
</template>

<script>
import { selectClipLibraryAll } from '@/request/new/videosucai'
import { ElMessage } from 'element-plus'
import { inject, reactive, toRefs, watch } from 'vue'
import { useRouter } from 'vue-router'
import paginationMax100 from '@/components/paginationMax100.vue' // 导入分页组件

export default {
  name: 'ylyPlayletBatchManage',
  components: { paginationMax100 },
  setup() {
    const router = useRouter()

    // 模板管理：新开页签跳转全局模板页面
    const openGlobalTemplatePage = () => {
      const routeData = router.resolve({ path: '/ylyGlobalTemplate' })
      window.open(routeData.href, '_blank')
    }

    const state = reactive({
      // 条数
      pagesize: 20,
      // 当前页数
      currentPage: 1,
      // 总数
      total: 100,
      // 页数 发生改变
      handleCurrentChange: (e) => {
        state.currentPage = e
        selectClipLibraryAllFun()
      },
      // 个数 发生改变
      handleSizeChange: (e) => {
        state.pagesize = e
        selectClipLibraryAllFun()
      },
    })

    const selectClipLibraryAllFun = () => {
      console.log('state.day', state.day)
      const datas = {
        currenPage: state.currentPage,
        size: state.pagesize,
        createTime: state.day,
        accountId: state.accountId2,
      }
      selectClipLibraryAll(datas).then((res) => {
        state.currentPage = res.data.currenPage
        state.total = res.data.totalSize
        state.tableData = res.data.data
      })
    }

    // selectClipLibraryAllFun()
    return {
      // 结构赋值，暴露出去就不用 state.xx
      ...toRefs(state),
      selectClipLibraryAllFun,
      openGlobalTemplatePage,
    }
  },
}
</script>

<style lang="scss" scoped>
.btn-toolbar {
  padding-bottom: 10px;
}
</style>
